<table mat-table [dataSource]="rows" class="mat-elevation-z8">
  @for (column of config.columns; track $index) { @if (column.id == "options") {
  <ng-container matColumnDef="{{ column.id }}">
    <th mat-header-cell *matHeaderCellDef>Options</th>
    <td mat-cell *matCellDef="let row">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (detailsbutton) {
        <button mat-menu-item (click)="detailsElement(row)">
          <mat-icon>info</mat-icon>
          <span>Détails</span>
        </button>
        } @if (updatebutton) {
        <button mat-menu-item (click)="updateElement(row)">
          <mat-icon>update</mat-icon>
          <span>Modifier</span>
        </button>
        } @if (deletebutton) {
        <button mat-menu-item (click)="deleteElement(row)">
          <mat-icon>delete</mat-icon>
          <span>Supprimer</span>
        </button>
        }
        @if (affranchibutton) {
          <button mat-menu-item (click)="affranchiElement(row)">
            <mat-icon>report_off</mat-icon>
            <span>Affranchir l'incident</span>
          </button>
          }
      </mat-menu>
    </td>
  </ng-container>
  } @else {
  <ng-container matColumnDef="{{ column.id }}">
    <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
    <td (click)="clickRow(row)" mat-cell *matCellDef="let row">
      {{ getPropertyValue(column, row) }}
    </td>
  </ng-container>
  } }

  <tr mat-header-row *matHeaderRowDef="getColumnNames()"></tr>
  <tr mat-row *matRowDef="let row; columns: getColumnNames()" [ngClass]="{'hover-row': isClickable}" ></tr>
</table>

<mat-paginator
  [length]="pageInformations.totalElements"
  [pageSize]="pageInformations.size"
  [pageSizeOptions]="[10]"
  (page)="onPageEvent($event)"
  style="margin-top: 16px"
>
</mat-paginator>
